import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Flip, ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { Tooltip } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(names, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(names) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export default function Task() {
    const [data, setData] = useState([]);
    const [fData, setFData] = useState([]);
    const [names, setNames] = useState([]);
    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);
    const [sApi, setSApi] = useState(true);
    const [loading, setLoading] = useState(true);
    const aID = sessionStorage.getItem('aID');
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
        fontFamily: 'Montserrat'
    }));

    const redirect = () => {
        return "/coredataegap"
    };

    const processUniques = (data) => {
        let arr = [];
        data.forEach(ob => {
            if (!arr.includes(ob.user__email)) {
                arr.push(ob.user__email);
            }
        });
        return arr;
    };

    // const handleTasksFromS3 = (e) => {
    //     if (!sApi) {
    //         axios.get("http://3.218.107.133:8000/ocr/s3data/", {
    //             headers: {
    //                 Accept: "application/json"
    //             }
    //         })

    //             .then((response) => {
    //                 if (response.status === 200) {
    //                     if (response.data.msg.length > 0) {
    //                         setData(response.data.msg);
    //                         setFData(response.data.msg);
    //                         setNames(processUniques(response.data.msg));
    //                     }
    //                     else if (response.data.msg.length === 0) {
    //                         toast.info("No Task Assigned");
    //                     }
    //                 }
    //             })

    //             .catch((error) => {
    //                 alert("Server Error");
    //                 // console.log(error);
    //             })
    //     } else if (sApi) {
    //         axios.get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/`, {
    //             headers: {
    //                 Accept: "application/json"
    //             }
    //         })

    //             .then((response) => {
    //                 if (response.status === 200) {
    //                     if (response.data.msg.length > 0) {
    //                         setData(response.data.msg);
    //                         setFData(response.data.msg);
    //                         setNames(processUniques(response.data.msg));
    //                     }
    //                     else if (response.data.msg.length === 0) {
    //                         toast.info("No Task Assigned");
    //                     }
    //                 }
    //             })

    //             .catch((error) => {
    //                 alert("Server Error");
    //                 // console.log(error);
    //             })
    //     }
    //     setSApi(val => !val);
    // };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/s3data/`, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.msg.length > 0) {
                        console.log(response.data.msg)
                        setData(response.data.msg);
                        setFData(response.data.msg);
                        setNames(processUniques(response.data.msg));
                        setLoading(false);
                    }
                    else if (response.data.msg.length === 0) {
                        toast.info("No Task Assigned");
                    }
                }
            })
            .catch((error) => {
                alert("Server Error");
                console.log(error);
            })
    }, []);

    useEffect(() => {
        if (personName.length === 0 && data.length > 0) {
            setFData(data);
        }
        else if (personName.length > 0) {
            const arr = [];
            personName.forEach(it => {
                data.forEach(ea => {
                    if (it === ea.user__email) {
                        arr.push(ea);
                    }
                });
            });
            setFData(arr);
        }
        // console.log(personName);
    }, [personName]);

    useEffect(() => {
        function handleContextMenu(e) {
            e.preventDefault();
        }
        const rootElement = document.getElementById('my-component');
        rootElement.addEventListener('contextmenu', handleContextMenu);
        return () => {
            rootElement.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    const handleKeyDown = (e) => {

        // if (e.keyCode === 123) {
        //     e.preventDefault();
        // }
        if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.keyCode === 85) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
            e.preventDefault();
        }
    };


    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const handleDelete = (valueToRemove) => {
        setPersonName((prev) => prev.filter((value) => value !== valueToRemove));
    };  // Remove the chip when the x icon is clicked

    // useEffect(() => {
    //     if (sessionStorage.getItem('aID') && !loading) {
    //         console.log(parseInt(sessionStorage.getItem('aID')))
    //         const timer = setTimeout(() => { document.getElementById(parseInt(sessionStorage.getItem('aID')))?.scrollIntoView({ behavior: 'smooth' }); }, 1000)

    //         return () => clearTimeout(timer)
    //     }
    // }, [loading])
    useEffect(() => {
        if (sessionStorage.getItem('aID') && !loading) {
            console.log(parseInt(sessionStorage.getItem('aID')))
            const timer = setTimeout(() => { document.getElementById(parseInt(sessionStorage.getItem('aID'))); }, 1000)

            return () => clearTimeout(timer)
        }
    }, [loading])

    return (
        <div id='my-component' className='' style={{ display: 'flex', flexDirection: 'column' }} onKeyDown={(e) => handleKeyDown(e)}>


            {/* <Tooltip title="Logout" placement="bottom" >
                <button
                    onClick={() => {
                        sessionStorage.clear();
                        window.location.reload()
                    }}
                    className=" absolute text-white text-2xl font-semibold hover:text-orange-500 top-0 right-0 mr-4 mt-4">
                    <IoLogOut fontSize={40} />
                </button>
            </Tooltip> */}
            {/* <FormGroup>
                <FormControlLabel
                    control={
                        <Switch checked={sApi} onChange={(e) => handleTasksFromS3(e)} name="S3" />
                    }
                    label="S3"
                />
            </FormGroup> */}
            {/* <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-chip-label">Select</InputLabel>
                <Select
                    labelId="demo-multiple-chip-label"  
                    id="demo-multiple-chip" 
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value}  />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {names.length > 0 && names.map((name) => (
                        <MenuItem
                            key={name}
                             value={name}
                            style={getStyles(name, personName, theme)}
                        >
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl> */}
            <div className='flex  items-center justify-start   mt-4 w-full p-4  border-b-2 border-black sticky  z-10" ' style={{ justifyContent: "space-between", width: "100%" }}>
                <div className='flex items-center justify-start gap-4' >
                    <button className='ml-4' ><IoIosArrowBack fontSize={24} /></button>
                    <div style={{ background: 'transparent', color: 'black' }} className="title text-center  justify-start   font-Montserrat text-3xl ">{"PENDING TASKS"}</div>
                </div>

                <FormControl sx={{ m: 1, width: 300, color: 'white' }}>
                    <InputLabel sx={{ color: 'black' }} id="demo-multiple-chip-label">Select</InputLabel>
                    <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={personName}
                        onChange={handleChange}
                        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, backgroundColor: 'transparent' }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} sx={{ color: 'white' }}
                                        onDelete={() => handleDelete(value)} 
                                    />
                                ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                    >
                        {names.length > 0 &&
                            names.map((name) => (
                                <MenuItem
                                    key={name}
                                    value={name}
                                    style={getStyles(name, personName, theme)}
                                >
                                    {name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </div>
            {/* <div className="h-px bg-gray-700 w-full"></div> */}

            <div
                className="flex flex-wrap justify-center gap-8  overflow-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400 scrollbar-track-gray-200 p-4"
                style={{ flex: 1 }}
            >
                {fData.length > 0 && fData.map((t, index) => (
                    <div className={` shadow-2xl rounded-lg p-6 w-72 gap-6 text-cyan-900 
                        ${t?.callout_count !== null && t?.callout_count > 30 ? 'bg-red-300'
                            : t?.callout_count > 0 ? 'bg-green-200'
                                : 'bg-green-200'} 
                                ${aID && parseInt(aID) === t?.id && 'border-4 border-black '}`} style={{ width: '350px' }} key={t.id} id={t.id}
                    >
                        <div color="blue-gray" className="relative h-56 pr-3 w-80 overflow-hidden  " >
                            <img
                                src={`${t.image_urls?.[0]}`}
                                alt='Mechanical Drawing'
                                loading="lazy"
                            />
                            <br />

                        </div>
                        <div className='flex  justify-center  gap-4 grid-cols-2'>
                            <h5 className="status font-medium text-cyan-900">{index + 1}</h5>
                            <br />
                            <h6 className="status font-medium text-cyan-900">{t?.task_status}</h6>
                            <h6 className="status font-medium text-cyan-900">{t?.id}</h6>
                        </div>
                        <h6 className="status font-medium  flex justify-center">{t?.user__email.split('@')[0]}</h6>
                        <br />
                        {/* <Link
                            className="bg-cyan-950 text-white font-mono font-semibold py-2 px-4 rounded-lg hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full text-center block"
                            to={{
                                pathname: redirect(),
                                state: `${t.id}:${sApi ? 's3data' : 'onetask'}`
                            }}>
                            Enter
                        </Link> */}
                        <Link
                            className="bg-[#1E5045] text-white font-mono font-semibold py-2 px-4 rounded-lg hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full text-center block"
                            to={{
                                pathname: redirect(), // Path to the next page
                                state: {
                                    id: t.id, // Pass the id here as part of an object
                                    source: sApi ? 's3data' : 'onetask' // Pass the source dynamically
                                },
                            }}
                        >
                            Enter
                        </Link>
                    </div>
                ))}
            </div>
            <ToastContainer transition={Flip} />
        </div>
    );
}